import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MapsAPILoader } from '@agm/core';

// just an interface for type safety.
interface MapMarker {
  lat: number;
  lng: number;
  draggable: boolean;
  content?: string;
  isShown: boolean;
  icon: any;
  id: string;
  images: any;
  name: string;
  rentalPrice: any;
}

@Component({
  selector: 'app-map-result',
  templateUrl: './map-result.component.html',
  styleUrls: ['./map-result.component.scss']
})

export class MapResultComponent implements OnInit {

  title: string = 'AGM project';
  latitude: number = 1.3543944;
  longitude: number = 103.8650793;
  zoom: number = 11;
  address: string;
  private geoCoder;

  // Radius
  radius = 10000;
  radiusLat = 0;
  radiusLong = 0;

  @Input() listings: any;
  markers: MapMarker[];

  constructor(
    private mapsAPILoader: MapsAPILoader
  ) {

  }

  ngOnInit() {
    //load Map
    this.mapsAPILoader.load().then(() => {
      this.initializeMap();
    });
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }
  }

  initializeMap() {
    this.radiusLat = this.latitude;
    this.radiusLong = this.longitude;
    this.zoom = 11;

    this.updateMarkers();
    this.setCurrentLocation();
  }

  updateMarkers() {
    this.markers = [];

    (this.listings || []).forEach(list => {
      if (list.address && list.address.lat && list.address.lng) {
        this.markers.push({
          lat: list.address.lat,
          lng: list.address.lng,
          draggable: true,
          content: `${list.location}`,
          isShown: true,
          icon: {
            url: './assets/images/rent-reef-icon.svg',
            scaledSize: {
              width: 25,
              height: 25
            }
          },
          id: list.id || list.objectID,
          images: list.images,
          name: list.name,
          rentalPrice: list.rentalPrice
        })
      }
    });
  }

  ngOnChanges() {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
    });

    this.updateMarkers();
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }

  radiusDragEnd($event: any) {
    console.log($event);
    this.radiusLat = $event.coords.lat;
    this.radiusLong = $event.coords.lng;
    this.showHideMarkers();
  }

  event(type, $event) {
    console.log(type, $event);
    this.radius = $event;
    this.showHideMarkers();
  }

  showHideMarkers() {
    Object.values(this.markers).forEach(value => {
      value.isShown = this.getDistanceBetween(value.lat, value.lng, this.radiusLat, this.radiusLong);
    });
  }

  getDistanceBetween(lat1, long1, lat2, long2) {
    var from = new google.maps.LatLng(lat1, long1);
    var to = new google.maps.LatLng(lat2, long2);

    if (google.maps.geometry.spherical.computeDistanceBetween(from, to) <= this.radius) {
      console.log('Radius', this.radius);
      console.log('Distance Between', google.maps.geometry.spherical.computeDistanceBetween(
        from, to
      ));
      return true;
    } else {
      return false;
    }
  }

  getBackgroundImageStyle(evt) {

  }

}
